export class BaseEvent {
  constructor(public name: string) {
  }
}


